<div class="p-d-flex p-flex-column section score">

  <div class="p-d-flex p-flex-row p-ai-center p-jc-between header">
    <div class="p-d-flex p-flex-row p-ai-center title">
      <div class="circle accent">•</div>
      <span>
        Профессионализм
      </span>
      <app-rating-bar class="rating-bar p-d-md-block p-d-none" type="agent" [rating]="rating ?? 0"></app-rating-bar>
    </div>
  </div>

  <div class="body">
    <ng-container *ngIf="agentClientScore$ | async as scoreList">
      <ng-container *ngTemplateOutlet="scoreListTmpl;context:{ scoreList }"></ng-container>
    </ng-container>
  </div>

  <div class="p-d-flex p-flex-row p-ai-center p-jc-between header desktop-view">
    <div class="p-d-flex p-flex-row p-ai-center title">
      <div class="circle secondary">•</div>
      <span>
        Оценка клиента
      </span>
      <app-rating-bar class="rating-bar p-d-md-block p-d-none" type="client" [rating]="averageClientRating ?? 0"></app-rating-bar>
    </div>
  </div>

  <div class="body desktop-view">
    <ng-container *ngIf="agentScore$ | async as scoreList">
      <ng-container *ngTemplateOutlet="scoreListTmpl;context:{ scoreList }"></ng-container>
    </ng-container>
  </div>

</div>

<ng-template #scoreListTmpl let-scoreList="scoreList">
  <div class="p-d-flex p-flex-row list">

    <ng-template [ngIf]="scoreList.length > 0">

      <div class="p-d-flex p-flex-column p-ai-center score-item" *ngFor="let score of scoreList">
        <div class="icon">
          <img [src]="getImageUrl(score.icon)" alt="icon" loading="lazy">
        </div>
        <div class="name">
          {{score.name}}
        </div>
        <div class="count">
          {{score.count}}
        </div>
      </div>

    </ng-template>

    <ng-template [ngIf]="scoreList.length === 0">
      <div class="no-data">
        Нет оценок
      </div>
    </ng-template>

  </div>
</ng-template>
